import { render, staticRenderFns } from "./DefaultCopies.vue?vue&type=template&id=3666c266&"
import script from "./DefaultCopies.vue?vue&type=script&lang=js&"
export * from "./DefaultCopies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports